export default __webpack_public_path__ + "static/media/profile5.ed1cb5bd.png";